/**
 * Created by Qingger Corp.
 * User: Thinkpad
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 报名审核管理
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import { isPartiallyEmittedExpression } from 'typescript';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import imagePreview from '@/views/components/imgPreview';
import { noop, parseSec, showPlatform } from '@/util';
import ExportFile from '@/views/components/exportFile';
import NewSelectSite from '@/views/components/newSelectSIte'

interface RecruitApplyInfo {
  requestId?: number;
  buyerName?: string; // 申请人
  buyerPhone?: string; // 申请人手机号
  address?: string; // 住址
  requestAddTimeFm?: string; // 申请时间
  requestContent?: string; // 申请理由
  cardNumber?: string; // 身份证号
  cardPic?: string; // 身份证正
  cardBackPic?: string; // 身份证反
  applyEmpName?: string; // 审核人姓名（除审核外显示）
  applyAddTimeFm?: string; // 审核时间（除审核外显示）
  applyResult?: number; // 审核结果（除审核外显示）0审核中 1审核通过 2已拒绝 3黑名单(对于顾客来讲是已拒绝)
  applyRefuseContent?: string; // 拒绝理由（已拒绝时会显示）
  applyBlacklistContent?: string; // 黑名单理由（黑名单时会显示）
  recommendName?: string; // 邀请人
  recommendPhone?: string; // 邀请人手机号
  deposit?: number; // 押金（通过时会显示）
  policyType?: number; // 分销类型0顾客分销 1员工分销 2导购分销
  applicantType?: number; // 申请人类型0顾客 1员工 2导购（审核时显示）
  tagName?: string; // 角色标签
  policyName?: string; // 策略名
  inviteesTagName?: string; // 邀请人角色标签
  policyId?: number | string; // 分销策略Id
  bankCardInfo?: {
    bankName?: string,
  bankCardCode?: string|number;
  }

}

@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class RecruitConfirmManage extends Vue {
  /* 数据 */
  $refs: {
    export: ExportFile;
  };

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 报名审核管理列表
   * @type {Array<UserList>}
   */
  public userList: ItemArray = [];

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 排序名称
   * @type {string}
   */
  public orderName = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  /**
   * 是否选中user
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 虚拟店长审核弹窗是否显示
   * @type {boolean}
   */
  public isConfirmPopShow = false;

  // 弹框key

  public keydialog=0

  /**
   * 虚拟店长审核信息
   * @type {ItemObject}
   */
  public virtualManagerInfo: RecruitApplyInfo = {
    requestId: 0,
    buyerName: '',
    buyerPhone: '',
    address: '/',
    requestAddTimeFm: '/',
    requestContent: '/',
    cardNumber: '',
    cardPic: '',
    cardBackPic: '',
    applyEmpName: '',
    applyAddTimeFm: '/',
    applyResult: 0,
    applyRefuseContent: '/',
    applyBlacklistContent: '/',
    recommendName: '/',
    recommendPhone: '/',
    deposit: 0,
    policyType: 0,
    applicantType: 0,
    tagName: '/',
    policyName: '/',
    inviteesTagName: '/',
    policyId: '',
    bankCardInfo: {
          bankName: '',
    bankCardCode: ''
    }

  };

  /**
   * 拒绝理由类型
   * @type {number}
   */
  public rejectedReasonType = 'self';

  /**
   * 拒绝理由
   * @type {any}
   */
  public rejectedReason: any = '';

  /**
   * 拒绝理由列表
   * @type {Array<ItemObject>}
   */
  public rejectedReasonList: Array<ItemObject> = [];

  /**
   * 选中的列表项
   * @type Array<UserList>
   */
  public selectedUserList: Array<UserList> = [];

  /**
   * 当前图片地址
   * @type {string}
   */
  public curPic = '';

  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 是否通过状态
   * @type {string}
   */
  public applyType = 1;

  /**
   * 页面名称
   * @type {ItemObject}
   */
  public pageNameObj: ItemObject = {
    p1: 'VSHOP-FUNCTION-DISTRIBUTE-CONFIRM-WAIT', // 待审核
    p2: 'VSHOP-FUNCTION-DISTRIBUTE-CONFIRM-NEEDPAY', // 待缴押金
    p3: 'VSHOP-FUNCTION-DISTRIBUTE-CONFIRM-HASPAY', // 审核通过
    p4: 'VSHOP-FUNCTION-DISTRIBUTE-CONFIRM-HASDENY', // 不通过
    p5: 'VSHOP-FUNCTION-DISTRIBUTE-CONFIRM-BLACKLIST', // 黑名单
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * 标签
   * @type {string}
   */
  public tag = '0'; // 0 普通顾客、1 公司员工、2 公司导购、3 签约网红、4 黄牛

  /**
   * 标签筛选条件
   * @type {string}
   */
  public queryParamTag = '9'; // 0 普通顾客、1 公司员工、2 公司导购、3 签约网红、4 黄牛 9 全部

  /**
   * 角色标签类型
   * @type {string | name}
   */
  public tagType = '';

  /**
   * 角色标签列表
   * @type {ItemArray}
   */
  public tagTypeList = [];

  /**
   * 分销策略列表
   * @type {ItemArray}
   */
  public distributionList = [];

  /**
   * 分销类型列表
   * @type {ItemArray}
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 分销类型
   * @type {number | string}
   */
  public distributionType = '';

  /**
   * 弹窗title
   * @type {string}
   */
  public dialogTitle = '审核详情';

  /**
   * 是否批量审核
   * @type {boolean}
   */
  public isBatchCheck = false;

  /**
   * 网点树
   * @type {ItemArray}
   */
  public siteTree: ItemArray = [];

  /**
   * 网点列表
   * @type {string[]}
   */
  public siteCodes: string[] = [];

  /**
   * 审核结果列表
   * @type {string[]}
   */
  public applyResultList: string[] = ['审核中', '审核通过', '已拒绝', '黑名单'];

  /**
   * 请求info状态
   */
  public infoRequestState = false;

  /**
   * 禁用状态
   */
  public confirmDisabled = false;

  // 是否展示银行卡

  public isShowBank=false

  /* 方法 */

  /**
   * 获取当前详情的序列号
   */
  get getIndex() {
    return this.userList.findIndex(v => v.requestId === this.virtualManagerInfo.requestId);
  }

  /**
   * 获取当前页是否为最后一页
   */
  get lastPage() {
    return this.page === Math.ceil(this.totalCount / this.pageSize);
  }

  public socketStatus = 0;

  public downLoadUrl = '';

  public key = 0
  /**
   * 监听弹窗关闭时则重新获取列表
   */
  @Watch('isConfirmPopShow')
  watchDialog(n, o) {
    if (!n) {
      this.isBatchCheck = false;
      this.applyType = 1;
      this.rejectedReason = '';
      this.rejectedReasonType = 'self';
      this.infoRequestState = false;
      this.onGetUserList();
    }
  }

  /**
   * 切换页面
   * @return null
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    this.queryParamTag = '9';
    this.setCurPageName(key); // 设置当前页索引到缓存
    this.$refs.export.reset();
    // 表格恢复到初始状态
    // @ts-expect-error
    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
    // @ts-expect-error
    this.$refs.multipleTable.bodyWrapper.scrollLeft = 0;
    this.page = 1;
    this.pageSize = 10;
    this.orderBy = '';
    this.orderBy = '';
    this.keywords = '';
    this.isSelected = false;
    this.selectedUserList = [];
    this.siteCodes = [];
    this.distributionType = '';
    this.tagType = '';
    this.onGetUserList();
    this.getTagList();
  }

  /**
   * 点击树节点时
   * @param {number} item
   */
  // public onClickNode(item) {
  //   this.page = 1;
  //   this.pageSize = 10;
  //   this.siteCodes = this.getTreeAllSite(item);
  //   this.onGetUserList();
  //   this.getTagList();
  //   this.isSelected = false;
  //   this.selectedUserList = [];
  // }

  /**
   * 获取该节点下所有code
   * @returns {string[]}
   */
  // getTreeAllSite(data) {
  //   const childSite = [];
  //   const deepSearch = (node) => {
  //     if (node.isSite) {
  //       childSite.push(node.code);
  //       return;
  //     } else if (Array.isArray(node.children) && node.children.length) {
  //       node.children.forEach((i) => {
  //         deepSearch(i);
  //       });
  //     }
  //   };
  //   deepSearch(data);
  //   return childSite;
  // }

  /**
   * 获取左侧树列表
   * @return null
   */
  // getTreeList() {
  //   return IPSService.getAdminAuthTree().then((response) => {
  //     return response.treeList;
  //   });
  // }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.siteCodes = val;
      this.onGetUserList();
      this.getTagList()
    }, noop);
  }
  public dateChange() {
    this.page = 1;
    this.onGetUserList();
  }

  /**
   * 获取报名审核列表
   * @return null
   */
  public async onGetUserList() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    const postParams = {
      type: Number.parseInt(this.curPage), // 1待审核 2待交押金 3已交押金 4已拒绝 5黑名单
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
      order: this.orderName,
      orderBy: this.orderBy,
      tag: Number.parseInt(this.queryParamTag),
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      siteCodes: this.siteCodes,
    };
    // if (!this.siteTree || !this.siteTree.length) {
    //   this.siteTree = await this.getTreeList();
    // }
    return IPSService.guiderRequestList({ postParams }).then(
      (res: any) => {
        if (res.list.length > 0) {
          // 格式化数据
          res.list.forEach((item) => {
            item.deposit = item.deposit ? (item.deposit / 100).toFixed(2) : 0;
            item.applyRefuseContent = Functions.emptyVaribleHandler(item.applyRefuseContent);
            item.applyBlacklistContent = Functions.emptyVaribleHandler(item.applyBlacklistContent);
            item.payTime = Functions.emptyVaribleHandler(item.payTime);
            item.requestAddTime = Functions.emptyVaribleHandler(item.requestAddTime);
            item.applyAddTime = Functions.emptyVaribleHandler(item.applyAddTime);
            item.siteName = Functions.emptyVaribleHandler(item.siteName);
            item.bankCardCode=item.bankCardInfo.bankCardCode?item.bankCardInfo.bankCardCode:'';
            item.bankName=Functions.emptyVaribleHandler(item.bankCardInfo.bankName);
          });
        }
        this.userList = res.list;
        this.key = Math.random()
        this.totalCount = res.count;
        loading.close();
      },
      () => {
        loading.close();
      },
    );
  }

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: this.siteCodes,
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }

  /**
   * 获取分销策略列表
   * @return null
   */
  public getDistributionList(siteId, policyType, openState = 1) {
    return IPSService.newDistributionList({
      postParams: {
        siteId,
        policyType,
        openState,
      },
    }).then((response) => {
      return response.list;
    });
  }

  /**
   * 列表排序
   * @param {any} val
   */
  public onSortChange(val: any): void {
    this.orderName = val.prop;
    this.orderBy = val.order === 'ascending' ? 'ASC' : 'DESC';
    this.onGetUserList();
  }

  /**
   * 根据关键字搜索
   * @return null
   */
  public onSearchUser(): void {
    this.page = 1;
    this.pageSize = 10;
    this.onGetUserList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.onGetUserList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.onGetUserList();
  }

  /**
   * 分销类型改变
   * @param {number} val
   */
  public distributionTypeChange(val) {
    this.distributionType = val;
    this.onGetUserList();
  }

  /**
   * 角色标签改变
   * @param {number} val
   */
  public tagTypeChange(val) {
    this.tagType = val;
    this.onGetUserList();
  }

  /**
   * 选中的活动
   * @param {Array<UserList>} val
   * @return null
   */
  public onHandleSelectionChange(val: Array<UserList>): void {
    this.isSelected = val.length > 0;
    this.selectedUserList = val;
  }

  /**
   * 隐藏虚拟店长审核弹窗
   * @return null
   */
  public onConfirmPopHide(): void {
    this.isConfirmPopShow = false;
  }

  /**
   * 获取虚拟店长详情(审核)
   * @param {number} id
   * @param {boolean} isInfo
   * @return null
   */
  public async onGetVirtualManagerInfo(id: number, isInfo: boolean, siteId, policyType) {
    this.getRejectedReasonList(); // 获取拒绝理由列表
    if (isInfo) {
      this.distributionList = await this.getDistributionList(siteId, policyType);
    }
    const queryParams = {
      requestId: id,
      type: Number(this.curPage),
    };
    IPSService.guiderRequestInfo({ queryParams }).then(
      (res) => {
        if (this.curPage === '1') {
          this.applyType = 1;
        } else {
          this.applyType = Number(res.applyResult);
        }
        res.policyId = res.policyId || '';
        (this.virtualManagerInfo as ItemObject) = res;
        this.keydialog=Math.random()
        this.isConfirmPopShow = true;
        this.infoRequestState = false;
        this.confirmDisabled = false;
        if (this.curPage === '1' && this.applyResultList[res.applyResult] && res.applyResult) {
          this.isConfirmPopShow = false;
          this.onGetUserList();
          this.$message.warning('数据已更新,请重试');
        }
      },
      () => {
        this.confirmDisabled = false;
      },
    );
  }

  /**
   * 获取拒绝理由列表
   * @return null
   */
  public getRejectedReasonList(): void {
    const queryParams = {
      type: 1, // 1：预定义拒绝理由，2：预定义提现理由
    };
    IPSService.rejectContentList({ queryParams }).then((res) => {
      this.rejectedReasonList = [];
      res.list.forEach((item, index) => {
        this.rejectedReasonList.push({ id: index, label: item });
      });
    });
  }

  /**
   * 审核弹窗拒绝理由
   * @param {number|string} val
   * @return null
   */
  public onRejectedReasonTypeChange(val: any): void {
    if (val !== 'self') {
      const value = this.rejectedReasonList.find((item) => {
        return item.id === val;
      });
      this.rejectedReason = value.label;
    } else {
      this.rejectedReason = '';
    }
  }

  /**
   * 重新格式化图片地址
   * @param {string} key
   */
  public reCreateImgSrc(key: string): void {
    this.virtualManagerInfo[key] = require('../../../../static/img/boxBgImg.svg');
  }

  /**
   * 提交虚拟店长审核信息
   * 需要关闭弹窗 close true 需要 false 不需要
   * @param {boolean} close
   * @return null
   */
  public onSubmit(close = false) {
    let requestId = [];
    this.isBatchCheck ? (requestId = this.selectedUserList.map(v => v.requestId)) : (requestId = [`${this.virtualManagerInfo.requestId}`]);
    this.confirmDisabled = true;
    return !this.isBatchCheck && this.applyType === 1
      ? IPSService.guiderRequestPolicyChange({
        postParams: {
          requestId: this.virtualManagerInfo.requestId,
          policyId: this.virtualManagerInfo.policyId,
        },
      }).then(
        (response) => {
          this.guiderRequestSave(requestId).then(() => {
            this.isConfirmPopShow = !close;
            this.confirmDisabled = false;
          });
        },
        () => {
          this.isConfirmPopShow = false;
          this.confirmDisabled = false;
        },
      )
      : this.guiderRequestSave(requestId).then(() => {
        this.isConfirmPopShow = !close;
        this.confirmDisabled = false;
      });
  }

  /**
   * 确认审核提示
   * isBatchCheck 是否批量审核 true 是false 不是
   * @param {boolean} isBatchCheck
   */
  public onConfirmSubmit(isBatchCheck = false) {
    if (!isBatchCheck && !this.virtualManagerInfo.policyId) {
      this.$message.warning('请选择分销策略');
      return;
    }
    if ((this.applyType === 2 || this.applyType === 3) && (!this.rejectedReason || !this.rejectedReason.trim())) {
      this.$message.warning('请填写拒绝理由');
      return;
    }
    this.$confirm(`确认进行${isBatchCheck ? '批量' : ''}审核吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((result) => {
      if (result === 'confirm') {
        this.onSubmit(true).catch(() => {
          this.confirmDisabled = false;
        });
      }
    }, noop);
  }

  /**
   * 审核申请
   * @return null
   */
  public guiderRequestSave(requestId) {
    const postParams = {
      requestId: requestId.join('|'), // 申请ID，多个用|分割开
      applyResult: this.applyType, // 1审核通过 2已拒绝 3黑名单(对于顾客来讲是已拒绝)
      applyContent: this.rejectedReasonType === 'self' ? this.rejectedReason : this.rejectedReasonList[this.rejectedReasonType].label, // 加入黑名单/拒绝理由
    };
    return IPSService.guiderRequestSave({ postParams }).then(
      (res) => {
        if (res) {
          this.$message.success('提交成功');
          this.rejectedReason = '';
          this.rejectedReasonType = 'self';
        }
      },
      () => {
        this.isConfirmPopShow = false;
        this.confirmDisabled = false;
        this.onGetUserList();
      },
    );
  }

  /**
   * 虚拟店长移除黑名单
   * @param {number} id
   * @return null
   */
  public onRemoveFromBackList(id: number): void {
    const postParams = {
      requestId: `${id}`, // 申请ID
    };
    IPSService.requestRemoveBlacklist({ postParams }).then((res) => {
      if (res) { this.onGetUserList(); } // 获取虚拟店长列表
    });
  }

  /**
   * 报名审核批量通过
   * @return null
   */
  public onConfirmMul(): void {
    this.getRejectedReasonList();
    this.isBatchCheck = true;
    this.isConfirmPopShow = true;
  }

  /**
   * 批量移出黑名单
   * @return null
   */
  public onRemoveFromBackListMul(): void {
    const requestIdList = [];
    this.selectedUserList.forEach((item) => {
      requestIdList.push(item.requestId);
    });
    const postParams = {
      requestId: requestIdList.join('|'), // 申请ID
    };
    IPSService.requestRemoveBlacklist({ postParams }).then((res) => {
      if (res) { this.onGetUserList(); } // 获取虚拟店长列表
    });
  }

  /**
   * 图片放大
   * @param {string} item
   * @return null
   */
  public onMagnifyPic(item: string): void {
    this.curPic = item;
    this.isMagnifyPopShow = true;
  }

  get exportParams() {
    const postParams = {
      exportType: 'guiderRequestExport',
      params: {
        type: Number.parseInt(this.curPage), // 1待审核 2待交押金 3已交押金 4已拒绝 5黑名单
        keywords: this.keywords,
        order: this.orderName,
        orderBy: this.orderBy,
        tag: this.queryParamTag,
      },
    };
    return postParams;
  }

  /**
   * 判断菜单权限
   * @param {string} name
   * @return {boolean}
   */
  public menuAuth(name: string): boolean {
    return this.$store.state.authMenuCodeList.includes(name);
  }

  /**
   * 获取当前页索引
   * @return null
   */
  public getNearCurPage(): void {
    // 找到最近的
    if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p1)) {
      this.curPage = '1';
      localStorage.setItem('curPageName', this.pageNameObj.p1);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p2)) {
      this.curPage = '2';
      localStorage.setItem('curPageName', this.pageNameObj.p2);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p3)) {
      this.curPage = '3';
      localStorage.setItem('curPageName', this.pageNameObj.p3);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p4)) {
      this.curPage = '4';
      localStorage.setItem('curPageName', this.pageNameObj.p4);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p5)) {
      this.curPage = '5';
      localStorage.setItem('curPageName', this.pageNameObj.p5);
    }
    this.setCurPageName(this.curPage);
  }

  /**
   * 菜单名称和索引转换
   * @param {string} val
   * @return null
   */
  public getCurPage(val: string): void {
    switch (val) {
      case this.pageNameObj.p1:
        this.curPage = '1';
        break;
      case this.pageNameObj.p2:
        this.curPage = '2';
        break;
      case this.pageNameObj.p3:
        this.curPage = '3';
        break;
      case this.pageNameObj.p4:
        this.curPage = '4';
        break;
      case this.pageNameObj.p5:
        this.curPage = '5';
        break;
    }
  }

  /**
   * 设置当前页名称
   * @return null
   */
  public setCurPageName(key: string): void {
    // 设置缓存
    switch (key) {
      case '1':
        localStorage.setItem('curPageName', this.pageNameObj.p1);
        break;
      case '2':
        localStorage.setItem('curPageName', this.pageNameObj.p2);
        break;
      case '3':
        localStorage.setItem('curPageName', this.pageNameObj.p3);
        break;
      case '4':
        localStorage.setItem('curPageName', this.pageNameObj.p4);
        break;
      case '5':
        localStorage.setItem('curPageName', this.pageNameObj.p5);
        break;
    }
  }

  /**
   * 设置菜单权限
   * @return null
   */
  public menuAuthSet(): void {
    if (localStorage.getItem('curPageName')) {
      this.getCurPage(localStorage.getItem('curPageName'));
    } else {
      this.getNearCurPage();
    }
  }

  /**
   * 身份证预览
   * @param {string} url
   */
  public imagePreview(img) {
    imagePreview.open({ img }).catch(() => { });
  }

  /**
   * 获取申请人后面红字
   * @param {number,number} applicantType , policyType
   * applicantType 0顾客 1员工 2本店导购 3集团导购
   * policyType 0顾客分销 1员工分销 2导购分销
   */
  public getApplyIdentity() {
    let result = '<span></span>';
    const identity = ['顾客', '员工', '导购', '导购'];
    switch (this.virtualManagerInfo.policyType) {
      case 0:
        this.virtualManagerInfo.applicantType != 0 && (result = `<span>(<span class='redText'>该申请人是${identity[this.virtualManagerInfo.applicantType]}</span>)</span>`);
        break;
      case 1:
        this.virtualManagerInfo.applicantType != 1 && (result = `<span>(<span class='redText'>该申请人是${identity[this.virtualManagerInfo.applicantType]}</span>)</span>`);
        break;
      case 2:
        this.virtualManagerInfo.applicantType != 2 && this.virtualManagerInfo.applicantType != 3 && (result = `<span>(<span class='redText'>该申请人是${identity[this.virtualManagerInfo.applicantType]}</span>)</span>`);
        break;
      default:
        break;
    }
    return this.curPage === '1' ? result : '';
  }

  /**
   * 上一位详情
   */
  public previousInfo() {
    this.infoRequestState = true;
    if (this.getIndex === 0 && this.page === 1) {
      this.$message.warning('没有更多了');
      this.infoRequestState = false;
    } else if (this.getIndex === 0 && this.page > 1) {
      this.page -= 1;
      this.onGetUserList().then(() => {
        this.onGetVirtualManagerInfo(this.userList[this.userList.length - 1].requestId, true, this.userList[this.userList.length - 1].siteId, this.userList[this.userList.length - 1].policyType);
      });
    } else {
      this.onGetVirtualManagerInfo(this.userList[this.getIndex - 1].requestId, true, this.userList[this.getIndex - 1].siteId, this.userList[this.getIndex - 1].policyType);
    }
  }

  /**
   * 下一位详情
   */
  public nextInfo() {
    this.infoRequestState = true;
    if (this.getIndex === this.userList.length - 1 && this.lastPage) {
      this.$message.warning('没有更多了');
      this.infoRequestState = false;
    } else if (this.getIndex === this.userList.length - 1 && !this.lastPage) {
      this.page += 1;
      this.onGetUserList().then(
        () => {
          this.onGetVirtualManagerInfo(this.userList[0].requestId, true, this.userList[0].siteId, this.userList[0].policyType);
        },
        () => {
          this.confirmDisabled = false;
        },
      );
    } else {
      this.onGetVirtualManagerInfo(this.userList[this.getIndex + 1].requestId, true, this.userList[this.getIndex + 1].siteId, this.userList[this.getIndex + 1].policyType);
    }
  }

  /**
   * 审核并进入下一位
   */
  public confirmSubmitAndNext() {
    this.infoRequestState = true;
    if ((this.applyType === 2 || this.applyType === 3) && (!this.rejectedReason || !this.rejectedReason.trim())) {
      this.$message.warning('请填写拒绝理由');
      return;
    }
    this.onSubmit().then(
      () => {
        if (this.getIndex === this.userList.length - 1) {
          this.$message.warning('没有更多了');
        } else {
          this.nextInfo();
        }
      },
      () => {
        this.confirmDisabled = false;
      },
    );
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-CONFIRM');
    if (this.isContentBodyShow) {
      const list = ['embryform', 'devtest2', 'really'];
      this.isShowBank = showPlatform(list)
      this.menuAuthSet();
      this.getTagList();
      this.onGetUserList(); // 获取报名审核列表
    }
  }

  /**
   * 选择标签
   * @param {string} value
   * @return null
   */
  public selectTag(value: string) {
    this.tag = value;
  }

  /**
   * 选择标签筛选条件
   * @param {string} value
   * @return null
   */
  public selectQueryParamTag(value: string) {
    this.queryParamTag = value;
    this.onGetUserList();
  }
}
